import React, { Component } from "react";
import { Link } from "react-router-dom";

class Footer extends Component {
  render() {
    return (
      <footer className="footer-area">
        {/* Start Footer TOp */}

        

        {/* End Footer TOp */}

        {/* Start Copyright Area */}
        <div className="copyright-area copyright-style--1">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 col-md-6 col-12">
                <div className="copyright text-center text-md-left">
                  <p>© {new Date().getFullYear()}, Eidocell. <br />Distributed under GPL-3.0 license</p>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-12">
                <div className="copyright-right text-center text-md-right mt_sm--20">
                  {/* <ul className="social-share justify-content-end">
                    <li>
                      <a href="https://twitter.com">
                        <i className="fab fa-twitter"/>
                      </a>
                    </li>
                    <li>
                      <a href="https://facebook.com">
                        <i className="fab fa-facebook-f"/>
                      </a>
                    </li>
                    <li>
                      <a href="https://instagram.com">
                        <i className="fab fa-instagram"/>
                      </a>
                    </li>
                  </ul> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* End Copyright Area */}
      </footer>
    );
  }
}

export default Footer;
